import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { TenantDisasterRecoveryComponent } from './tenant-disaster-recovery.component';
import { DisasterRecoveryInstancesComponent } from './disaster-recovery-instances/disaster-recovery-instances.component';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionGuard } from 'src/app/services/util/permission.guard';
import { ViewInstanceDetailsComponent } from './view-instance-details/view-instance-details.component';
import { ExternalTenantGuard } from 'src/app/services/util/external-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: TenantDisasterRecoveryComponent,
    title: 'Disaster Recovery',
    canActivate: [ExternalTenantGuard],
  },
  {
    path: ':blueprintId',
    component: DisasterRecoveryInstancesComponent,
    canActivate: [ExternalTenantGuard],
  },
  {
    path: ':blueprintId/instance/:instanceId/:solutionId',
    component: ViewInstanceDetailsComponent,
    canActivate: [ExternalTenantGuard],
  },
  {
    path: 'blueprints/:blueprintId',
    component: DisasterRecoveryInstancesComponent,
    canActivate: [ExternalTenantGuard],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantDisasterRecoveryRoutingModule {
}
